import React from "react";
import "./UPI_QR_Content.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function UPI_QR_Content() {
  return (
    <>
      <section className="UPI_QR_Content">
        <div className="add_upi_box_holder">
          <Link to={"/payment-method"}>
            <div className="icon_holder">
              <FontAwesomeIcon icon={faPlus} />
            </div>
          </Link>
          <p>Add UPI</p>
        </div>
      </section>
    </>
  );
}

export default UPI_QR_Content;
